// @flow
import { fragments as automatedNotesWrapperFragments } from "../../../../../../components/AutomatedNotesWrapper/graph";
import { fragments as currentViewersFragments } from "../../../../../../components/CurrentViewers/graph";
import { gql } from "@apollo/client";
import { fragments as notesWrapperFragments } from "../../../../../../components/NotesWrapper/graph";
import { fragments as orderStatusHeaderFragments } from "../../../../../../components/OrderStatusHeader/graph";
import { fragments as productionJobDetailFragments } from "../../../../../../components/ProductionJobDetail/graph";
import { fragments as productionJobListFragments } from "../../../../../../components/ProductionJobList/graph";
import { fragments as transfersGlitterOrderStatusFragments } from "../../TransfersGlitterOrderStatus/graph";
import { fragments as transfersStandardOrderStatusFragments } from "../../TransfersStandardOrderStatus/graph";
import { fragments as transfersUVOrderStatusFragments } from "../../TransfersUVOrderStatus/graph";


export default gql`
  query DTGOrderDetail($orderId: ID!) {
    viewer {
      ...CurrentViewers_viewer
    }
    order: node(id: $orderId) {
      ... on Order {
        ...AutomatedNotesWrapper_order
        ...TransfersStandardOrderStatus_order
        ...TransfersUVOrderStatus_order
        ...TransfersGlitterOrderStatus_order
        ...OrderStatusHeader_order
        ...NotesWrapper_order

        productionJobs {
          ...ProductionJobDetail_productionJob
          ...ProductionJobList_productionJobs
        }
        orderProductionJobEmbroiderySplit
      }
    }
  }
  ${automatedNotesWrapperFragments.order}
  ${currentViewersFragments.viewer}
  ${transfersStandardOrderStatusFragments.order}
  ${transfersUVOrderStatusFragments.order}
  ${transfersGlitterOrderStatusFragments.order}
  ${orderStatusHeaderFragments.order}
  ${notesWrapperFragments.order}
  ${productionJobDetailFragments.productionJob}
  ${productionJobListFragments.productionJobs}
`;
